export const parseRoutePath = (routePath: string) => {
  return (
    routePath
      .replace('eager/', '')
      .replace('lazy/', '')
      .replace(/\/src\/pages|index|(\.tsx$)/g, '')
      .replace(/\[\.{3}.+\]/, '*')
      .split('/')
      .map((subPath: string) => subPath.replace(/^\[(.+)\]$/, ':$1'))
      .join('/')
  );
};
